import { autorun } from "mobx";
var TotalTimeCalculator = /** @class */ (function () {
    function TotalTimeCalculator(parts, onChange) {
        this.parts = [];
        this.disposable = function () { };
        this.parts = parts;
        this.onChange = onChange;
    }
    TotalTimeCalculator.prototype.activate = function () {
        var _this = this;
        this.disposable = autorun(function () {
            _this.onChange(_this.getTotalMinutes());
        });
    };
    TotalTimeCalculator.prototype.getTotalMinutes = function () {
        return this.parts.reduce(function (xs, x) { return xs + x.valueInMinutes; }, 0);
    };
    TotalTimeCalculator.prototype.deactivate = function () {
        this.disposable();
    };
    return TotalTimeCalculator;
}());
export { TotalTimeCalculator };
//# sourceMappingURL=TotalTimeCalculator.js.map